import { render } from "./LogoutView.vue?vue&type=template&id=79062956&ts=true"
import script from "./LogoutView.vue?vue&type=script&lang=ts"
export * from "./LogoutView.vue?vue&type=script&lang=ts"

import "./LogoutView.vue?vue&type=style&index=0&id=79062956&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__